import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, Plus, Trash2, Pencil, X, Check } from "lucide-react";
import api, { apiError } from "../lib/api";
import { BrandMark } from "../components/Layout";
import { useLang } from "../context/LanguageContext";

export default function Recipients() {
  const nav = useNavigate();
  const { t } = useLang();
  const [items, setItems] = useState([]);
  const [name, setName] = useState(""); const [email, setEmail] = useState("");
  const [edit, setEdit] = useState(null);

  const load = useCallback(async () => { const { data } = await api.get("/recipients"); setItems(data); }, []);
  useEffect(() => { load(); }, [load]);

  const add = async () => {
    if (!name.trim() || !email.trim()) return toast.error(t("Name and email required"));
    try { await api.post("/recipients", { name: name.trim(), email: email.trim() }); setName(""); setEmail(""); toast.success(t("Recipient added")); load(); }
    catch (e) { toast.error(apiError(e)); }
  };
  const save = async () => { try { await api.put(`/recipients/${edit.id}`, { name: edit.name, email: edit.email }); setEdit(null); toast.success(t("Saved")); load(); } catch (e) { toast.error(apiError(e)); } };
  const del = async (id) => { if (!window.confirm(t("Delete this recipient?"))) return; try { await api.delete(`/recipients/${id}`); load(); } catch (e) { toast.error(apiError(e)); } };

  return (
    <div className="min-h-screen bg-[#0A0A0A] max-w-md mx-auto sm:max-w-2xl md:max-w-4xl border-x border-zinc-800/40 pb-10">
      <div className="sticky top-0 z-40 bg-[#0A0A0A]/90 backdrop-blur-md px-4 py-4 border-b border-zinc-800/70 flex items-center justify-between">
        <button onClick={() => nav("/profile")} className="flex items-center gap-2 text-zinc-300"><ArrowLeft size={20} /> {t("Profile")}</button>
        <BrandMark />
      </div>
      <div className="px-4 pt-4">
        <h1 className="text-2xl font-extrabold text-white">{t("Office Recipients")}</h1>
        <p className="text-zinc-400 text-sm">{t("Where completed reports get emailed.")}</p>
        <div className="flex gap-2 mt-4">
          <input className="flex-1 bg-[#1c1c1f] border border-zinc-800 text-white rounded-xl px-3 py-2.5 focus:border-[#F26722] focus:outline-none" placeholder={t("Name")} value={name} onChange={(e) => setName(e.target.value)} data-testid="recipient-name-input" />
          <input className="flex-1 bg-[#1c1c1f] border border-zinc-800 text-white rounded-xl px-3 py-2.5 focus:border-[#F26722] focus:outline-none" placeholder={t("Email")} value={email} onChange={(e) => setEmail(e.target.value)} data-testid="recipient-email-input" />
          <button onClick={add} className="bg-[#F26722] text-white rounded-xl px-4" data-testid="recipient-add-btn"><Plus size={18} /></button>
        </div>
        <div className="mt-4 space-y-2">
          {items.map((o) => (
            <div key={o.id} className="flex items-center justify-between bg-[#18181B] border border-zinc-800 rounded-xl p-3.5">
              {edit?.id === o.id ? (
                <div className="flex gap-2 flex-1">
                  <input className="flex-1 bg-[#141416] border border-zinc-800 text-white rounded-lg px-2 py-1.5" value={edit.name} onChange={(e) => setEdit({ ...edit, name: e.target.value })} />
                  <input className="flex-1 bg-[#141416] border border-zinc-800 text-white rounded-lg px-2 py-1.5" value={edit.email} onChange={(e) => setEdit({ ...edit, email: e.target.value })} />
                  <button onClick={save} className="text-emerald-400"><Check size={18} /></button>
                  <button onClick={() => setEdit(null)} className="text-zinc-500"><X size={18} /></button>
                </div>
              ) : (
                <>
                  <div><p className="font-bold text-white">{o.name}</p><p className="text-xs text-zinc-500">{o.email}</p></div>
                  <div className="flex items-center gap-3">
                    <button onClick={() => setEdit({ id: o.id, name: o.name, email: o.email })} className="text-zinc-400"><Pencil size={16} /></button>
                    <button onClick={() => del(o.id)} className="text-red-400"><Trash2 size={18} /></button>
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
